function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: ".6",
  fill: "#54585D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.611 4H8.39A1.39 1.39 0 007 5.389v12.778a1.39 1.39 0 001.389 1.389h7.222A1.39 1.39 0 0017 18.166V5.39A1.39 1.39 0 0015.611 4zm-7.222.556h7.222c.46 0 .833.373.833.833v.833H7.556V5.39c0-.46.373-.833.833-.833zm8.055 11.666H7.556V6.778h8.888v9.444zM15.611 19H8.39a.834.834 0 01-.833-.833v-1.39h8.888v1.39c0 .46-.373.833-.833.833z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.612 5.667h2.777a.278.278 0 100-.556h-2.777a.278.278 0 100 .556zM13.11 17.055h-2.222a.834.834 0 000 1.667h2.222a.834.834 0 000-1.667zm0 1.111h-2.222a.278.278 0 010-.555h2.222a.278.278 0 010 .555z"
}))));